import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

import { ref, Ref, reactive, onBeforeMount } from 'vue'
import dayjs from 'dayjs';
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber } from '@/utils/index'
import store from '@/store/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'POST/checkin_approvals/report': fetchList,
  // 获取所有团队
  'GET/organizations': organizationsApi,
  // 获取所有公司
  'GET/company': companyApi,
} = Api

const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

const searchConfig = ref([
  {
    type: "TIME",
    label: "日期",
    value: [dayjs().startOf('month').format('YYYY-MM-DD'), dayjs().endOf('month').format('YYYY-MM-DD')],
    upKey: '_date',
    props: {
      type: 'daterange',
      'value-format': 'YYYY-MM-DD',
      clearable: false,
    }
  },
  {
    type: 'SELECT',
    label: '团队',
    value: '',
    upKey: 'orgId',
    options: store.getters.sysOrganizations,
    selectFunc: organizationsApi,
    props: {placeholder: '请选择团队'},
    seleProps: {label: 'name', valueName: 'id'}
  },
  {
    type: 'SELECT',
    selectType: 'GROUP',
    label: '公司',
    value: '',
    upKey: 'companyIds',
    options: store.getters.sysCompany,
    props: { clearable: true, multiple: true, 'collapse-tags': true, style: 'width: 350px', placeholder: '请选择公司'},
    seleProps: { label: 'name', valueName: 'id'}
  },
])

const searchHandle = (params: any) => {
  return fetchData({
    ...params,
    dateRange: {
      from: params._date?.[0],
      to: params._date?.[1],
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "异常报表-搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
            initSearch: true,
            title: true,
            searchConfig: searchConfig.value,
          }, {
              onSearchFn: _cache[0] || (_cache[0] = ($event: any) => (searchHandle($event)))
            }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      "max-height": _unref(MI_height) + 20 + 'px',
      data: _unref(MI_tableData),
      class: "mt-10"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "姓名",
          prop: "realName",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.realName + ' (' + row.alias + ')'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "公司",
          prop: "companyName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "团队",
          prop: "orgName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          label: "居家办公",
          prop: "home",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "时间",
          prop: "month",
          sortable: "",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          sortable: "",
          label: "补卡次数(3次及以上)",
          prop: "punchCorrection",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          sortable: "",
          label: "迟到早退(大于120分钟)",
          prop: "oneHundredTwenty",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          sortable: "",
          label: "迟到早退(大于250分钟)",
          prop: "towHundredFifty",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          sortable: "",
          label: "加班(时长大于40小时)",
          prop: "overtime",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"])
      ]),
      _: 1
    }, 8, ["max-height", "data"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[2] || (_cache[2] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mt-10",
      "page-sizes": [30, 50, 100, 300],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
  ]))
}
}

})